// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../../node_modules/react-datepicker/dist/react-datepicker.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* date picker customizations — keep the input flush inside the field shell */
.react-datepicker__input-container,
.react-datepicker-wrapper {
  cursor: pointer;
  width: 100%;
}

.react-datepicker__input-container > input{
  width: 100%;
  border-width: 0px;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.react-datepicker__input-container > input:focus{
  border-width: 0px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.react-datepicker__input-container > input {
  cursor: pointer;
}

.react-datepicker-popper {
  z-index: 9999;
}

.react-datepicker__day:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(7 160 173 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.react-datepicker__day--range-start,
.react-datepicker__day--range-end,
.react-datepicker__day--in-range,
.react-datepicker__day--keyboard-selected{
  --tw-bg-opacity: 1;
  background-color: rgb(178 236 231 / var(--tw-bg-opacity));
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(18 38 52 / var(--tw-text-opacity));
}

.react-datepicker__day--in-selecting-range:not(
    .react-datepicker__day--range-start,
    .react-datepicker__day--range-end,
    .react-datepicker__day--in-range
  ){
  --tw-bg-opacity: 1;
  background-color: rgb(178 236 231 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(18 38 52 / var(--tw-text-opacity));
}
`, "",{"version":3,"sources":["webpack://./src/styles/datepicker.css"],"names":[],"mappings":"AAEA,6EAA6E;AAC7E;;EAEE,eAAe;EACf,WAAa;AACf;;AAGE;EAAA,WAA+D;EAA/D,iBAA+D;EAA/D,8BAA+D;EAA/D;AAA+D;;AAA/D;EAAA,iBAA+D;EAA/D,2GAA+D;EAA/D,yGAA+D;EAA/D;AAA+D;;AADjE;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAGE;EAAA,kBAA2B;EAA3B,uDAA2B;EAA3B,oBAA2B;EAA3B;AAA2B;;AAO3B;;;;EAAA,kBAA0C;EAA1C,yDAA0C;EAA1C,gBAA0C;EAA1C,oBAA0C;EAA1C;AAA0C;;AAQ1C;;;;;EAAA,kBAA4B;EAA5B,yDAA4B;EAA5B,oBAA4B;EAA5B;AAA4B","sourcesContent":["@import 'react-datepicker/dist/react-datepicker.css';\n\n/* date picker customizations — keep the input flush inside the field shell */\n.react-datepicker__input-container,\n.react-datepicker-wrapper {\n  cursor: pointer;\n  @apply w-full;\n}\n\n.react-datepicker__input-container > input {\n  @apply w-full border-0 outline-none focus:border-0 focus:ring-0;\n  cursor: pointer;\n}\n\n.react-datepicker-popper {\n  z-index: 9999;\n}\n\n.react-datepicker__day:hover {\n  @apply bg-cabana text-duvet;\n}\n\n.react-datepicker__day--range-start,\n.react-datepicker__day--range-end,\n.react-datepicker__day--in-range,\n.react-datepicker__day--keyboard-selected {\n  @apply bg-pool font-semibold text-midnight;\n}\n\n.react-datepicker__day--in-selecting-range:not(\n    .react-datepicker__day--range-start,\n    .react-datepicker__day--range-end,\n    .react-datepicker__day--in-range\n  ) {\n  @apply bg-pool text-midnight;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
